import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const post = (users) =>
  requestsTemplates.post(mainPath, "/users",users);
